import {
  Shield,
  UserCheck,
  Users,
  Wallet,
  Target,
  Tag,
  Store,
  Bell,
} from 'lucide-react';

// Single source of truth for notification category presentation.
// Reused by the bell dropdown, the full-page Notification Center, and dashboard activity feeds.
export const CATEGORY_META = {
  account: { label: 'Account', icon: Shield, color: '#ef785b' },
  partner: { label: 'Partner', icon: UserCheck, color: '#6366f1' },
  client: { label: 'Clients', icon: Users, color: '#10b981' },
  commission: { label: 'Commissions', icon: Wallet, color: '#f59e0b' },
  lead: { label: 'Leads', icon: Target, color: '#3b82f6' },
  promo: { label: 'Promo', icon: Tag, color: '#a855f7' },
  marketplace: { label: 'Marketplace', icon: Store, color: '#ef785b' },
  general: { label: 'General', icon: Bell, color: '#64748b' },
};

export const getCategoryMeta = (category) => CATEGORY_META[category] || CATEGORY_META.general;

// Categories a partner can mute in Profile (account is intentionally excluded — always on).
export const MUTABLE_CATEGORIES = ['commission', 'lead', 'client', 'marketplace', 'promo', 'partner'];

export const SEVERITY_COLOR = {
  success: '#10b981',
  warning: '#f59e0b',
  info: '#64748b',
};

export const formatNotifTime = (iso) => {
  if (!iso) return '';
  const then = new Date(iso);
  const diffMs = Date.now() - then.getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return 'Just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 7) return `${days}d ago`;
  return then.toLocaleDateString();
};
